import { useContext } from 'react';
import { SnackbarContext } from '../components/wrappers/SnackbarProvider';

const useSnackbar = () => useContext(SnackbarContext);

export default useSnackbar;
